<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <cr-join-menu />
      </div>
    </div>
</section>
</template>

<script>
import crJoinMenuTemp from './Temp/CrJoinMenuTemp.vue'

export default {
  name: 'Tables',
  components: {
    'cr-join-menu': crJoinMenuTemp
  },
  methods: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// CrJoinMenu.vue?592a4883